module.exports = __webpack_public_path__ + "static/media/default-4.4a157fab.svg";